/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { GridTypeFromJSON, GridTypeToJSON, WidgetFromJSON, WidgetToJSON, } from './';
export function UpdateGridDataFromJSON(json) {
    return UpdateGridDataFromJSONTyped(json, false);
}
export function UpdateGridDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        type: !exists(json, 'type') ? undefined : GridTypeFromJSON(json['type']),
        config: !exists(json, 'config') ? undefined : json['config'],
        DocumentId: !exists(json, 'DocumentId') ? undefined : json['DocumentId'],
        Widgets: !exists(json, 'Widgets') ? undefined : json['Widgets'].map(WidgetFromJSON),
    };
}
export function UpdateGridDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        type: GridTypeToJSON(value.type),
        config: value.config,
        DocumentId: value.DocumentId,
        Widgets: value.Widgets === undefined ? undefined : value.Widgets.map(WidgetToJSON),
    };
}
